module.exports = __webpack_public_path__ + "public/images/slider/vebber-circle.211a03dd4f746c08dc337857727dc319.webp";